import { createContext, MutableRefObject } from 'react';

type TabContextType = {
  idTab: number | null;
  setIdTab: (idTab: number | null) => void;
  tabsRef: MutableRefObject<Element | null>;
  scrollToTabs: (id?: number) => void;
};

export const tabContext = createContext<TabContextType>({
  idTab: null,
  setIdTab: () => {
    // Empty function in the context.
  },
  tabsRef: { current: null },
  scrollToTabs: () => {
    // Empty function in the context.
  },
});
